import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import type { PersonProfileSection } from "../../api/person";

export const PersonProfileSections = ({
	sections,
}: {
	sections: PersonProfileSection[];
}) => {
	if (!sections || sections.length === 0) return null;

	// Group by section_type
	const grouped = new Map<number, PersonProfileSection[]>();
	for (const section of sections) {
		const existing = grouped.get(section.section_type);
		if (existing) {
			existing.push(section);
		} else {
			grouped.set(section.section_type, [section]);
		}
	}

	return (
		<>
			{Array.from(grouped.entries()).map(([sectionType, items]) => (
				<Grid key={sectionType} size={12} data-component="profile-section-grid">
					<Paper sx={{ p: 2 }} data-component="profile-section-paper">
						<Stack spacing={0.5} data-component="profile-section-group">
							<Typography
								variant="overline"
								color="text.secondary"
								sx={{
									fontWeight: "bold",
									letterSpacing: "0.5px",
									display: "block",
								}}
								data-component="section-type-label"
							>
								{items[0].section_type_label}
							</Typography>
							{items.map((item) => (
								<Stack
									key={item.id}
									spacing={0}
									data-component="section-item"
								>
									<Typography
										variant="body2"
										color="text.primary"
										sx={{ fontWeight: 600 }}
										data-component="section-title"
									>
										{item.title}
									</Typography>
									{item.subtitle && (
										<Typography
											variant="caption"
											color="text.secondary"
											data-component="section-subtitle"
										>
											{item.subtitle}
										</Typography>
									)}
									{item.description && (
										<Typography
											variant="body2"
											color="text.primary"
											sx={{ mt: 0.25 }}
											data-component="section-description"
										>
											{item.description}
										</Typography>
									)}
								</Stack>
							))}
						</Stack>
					</Paper>
				</Grid>
			))}
		</>
	);
};
